module.exports = __webpack_public_path__ + "static/media/Facebook.a8b317d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Facebook.svg
// module id = 299
// module chunks = 25